(function () {
  'use strict';

  angular
    .module('app.core')
    .config(coreConfig);

  coreConfig.$inject = ['$controllerProvider', '$compileProvider', '$filterProvider', '$provide', '$animateProvider', '$httpProvider'];

  function coreConfig($controllerProvider, $compileProvider, $filterProvider, $provide, $animateProvider, $httpProvider) {
    var core = angular.module('app.core');
    // registering components after bootstrap
    core.controller = $controllerProvider.register;
    core.directive = $compileProvider.directive;
    core.filter = $filterProvider.register;
    core.factory = $provide.factory;
    core.service = $provide.service;
    core.constant = $provide.constant;
    core.value = $provide.value;

    // Disables animation on items with class .ng-no-animation
    $animateProvider.classNameFilter(/^((?!(ng-no-animation)).)*$/);

    // Improve performance disabling debugging features
    // $compileProvider.debugInfoEnabled(false);

    // Disable cache
    $httpProvider.defaults.headers.common['Cache-Control'] = 'no-cache';
    $httpProvider.defaults.headers.common.Pragma = 'no-cache';
    $httpProvider.useApplyAsync(true);

    $httpProvider.interceptors.push(['$q', '$location', function ($q, $location) {
      return {
        'responseError': function (response) {
          function redirectToLogin() {
            $location.path('/login');
          }

          var additionalPublicPaths = ['/project-part-act-response', '/project-files-response'];

          var publicPaths = ['/login'].concat(additionalPublicPaths);

          if (publicPaths.indexOf($location.$$path) === -1) {
            if (response.status === 401 || response.status === 403) {
              redirectToLogin();
            }

            if (response.status === 400 && response.data) {
              if (['token_not_provided', 'token_invalid'].indexOf(response.data.error) !== -1) {
                redirectToLogin();
              }
            }

            if (response.status === 404 && response.data && response.data.error === 'user_not_found') {
              redirectToLogin();
            }
          }

          return $q.reject(response);
        }
      };
    }]);

    String.prototype.capitalize = function () {
      return this.charAt(0).toUpperCase() + this.slice(1);
    };

    String.prototype._replace = function () {
      return this.replace(/_/g, ' ');
    };

    String.prototype.trunc = String.prototype.trunc || function (n) {
      return (this.length > n) ? this.substr(0, n - 1) + '...' : this;
    };
  }
})();
